<template>
    <flex-element v-if="!hide" :element-type="elementType" tag="div">
        <o-container class="f-flex" v-bind="element(1)" @element-updated="elementUpdated">
            <template v-slot="{ element, elementUpdated }">
                <drop-zone-single
                    v-bind="element(1)"
                    @element-updated="elementUpdated"
                />
                <a-button
                    class="alert-dismiss"
                    v-bind="element(2)"
                    @element-updated="elementUpdated"
                    @click.native="dismissAlert"
                >
                    ×
                </a-button>
            </template>
        </o-container>
    </flex-element>
</template>

<script>
import baseOrganism from '@/mixins/base-organism/base-organism-dumb';

export default {
    mixins: [baseOrganism],

    data() {
        return {
            isDismissed: false,
        };
    },

    computed: {
        localStorageKey() {
            return `alert-banner-${ this.id }`;
        },

        hide() {
            return this.isDismissed;
        },
    },

    mounted() {
        this.setStatus();
    },

    methods: {
        dismissAlert() {
            // no point setting local storage in editor mode
            // as components can be moved around, deleted, recreated, etc
            // which will pollute their local storage data
            this.isDismissed = true;
            window.localStorage.setItem(this.localStorageKey, true);
        },

        setStatus() {
            this.isDismissed = !!window.localStorage.getItem(this.localStorageKey);
        },
    },
};
</script>

<style lang="scss">
.alert-dismiss {
    line-height: 0;
}
</style>
